import _ from 'underscore';
import ko from 'knockout';
import { getCharCountExcludingAdCustomizers as newGetCharCountExcludingAdCustomizers } from '@bingads-webui-campaign/ad-customizers';
import { getCharCountExcludingAdCustomizers as legacyGetCharCountExcludingAdCustomizers } from '@bingads-webui-campaign-legacy/crud-ad/service/adCustomizersUtils';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import config from '@bingads-webui-component-legacy/config/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import jsDataCampaign from '@bingads-webui-component-legacy/js-data-campaign/index';
import { i18nDummy } from '@bingads-webui-campaign-legacy/crud-ad/service/utils/i18n-dummy-vnext';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
const i18nAdCustomizers = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/ad-customizers');

const {
  IsNewAdsAdCustomizerEditorEnabled,
  IsIfFunctionMilestone1Enabled,
} = config.get('Permissions') || {};

const withNewAdCustomizerEditor = IsNewAdsAdCustomizerEditorEnabled ||
  IsIfFunctionMilestone1Enabled;

const getCharCountExcludingAdCustomizers = (value, name, adType = 'ExpandedTextAd', perfMarker) => {
  if (withNewAdCustomizerEditor) {
    return newGetCharCountExcludingAdCustomizers({
      text: value,
      field: name,
      deps: {
        i18n: i18nAdCustomizers,
        countdownI18nDummy: i18nDummy,
        config,
        instrumentation,
        edmCampaign,
        jsDataCampaign,
        perfMarker,
      },
      adType,
    });
  }

  return legacyGetCharCountExcludingAdCustomizers(value);
};

export default {
  extend(viewModel, propertyNames, adType = 'ExpandedTextAd') {
    const inputLimit = 4000;
    const perfMarker = viewModel.perfMarker;

    _.each(propertyNames, (name) => {
      const property = viewModel[name];

      // We need to force trigger a change notification to get property.strRemaining to be re-evaluated
      // using above override instead of the one from 'component\ko-schema-string\js\extension'
      if (typeof property === 'function') {
        // We don't use cjkRemaining for this form. So it's ok to only override this.
        property.remaining = ko.computed(() => {
          return property.maxLength() - getCharCountExcludingAdCustomizers(property(), name, adType, perfMarker);
        });
        property(property());
      } else {
        property.countCharCountExcludingAdCustomizers = () => {
          return getCharCountExcludingAdCustomizers(property.entity.get(name), name, adType, perfMarker);
        };
      }

      const lengthValidator = _.result(property.validators, 'maxLength') ||
        _.result(viewModel, ['model', 'validator', 'fieldValidators', name, 'validators', 'maxLength']);

      if (lengthValidator) {
        lengthValidator.isValid = (value) => {
          if (!value && lengthValidator.nullable) {
            return true;
          }

          if (_.isNull(value) || _.isUndefined(value)) {
            return false;
          }

          if (value.length > inputLimit) {
            return false;
          }

          return getCharCountExcludingAdCustomizers(value, name, adType, perfMarker) <= property.maxLength();
        };

        lengthValidator.message = function () {
          return i18n.get(`Ad_Validation_${name}LengthExceeded_New`, {
            count: property.maxLength(),
          });
        };

        lengthValidator.blockInput = false;
        lengthValidator.process = null;
      }
    });
  },
};
